import React from "react";
import TexCell from "../../../tables/components/atom/TexCell";
import { useNavigate, useParams } from "react-router-dom";

// Safely pull a phone value from multiple possible shapes/keys
function getPhone(c) {
  const candidates = [
    c?.phone,
    c?.Phone,
    c?.phoneNumber,
    c?.phonenumber,
    c?.mobile,
    c?.Mobile,
    c?.tel,
    c?.telephone,
    c?.contact?.phone,
    c?.contact?.mobile,
  ];
  const first = candidates.find(
    (v) => v !== undefined && v !== null && String(v).trim() !== ""
  );
  return first ? String(first).trim() : "-";
}

const CandidatesRow = ({ candidates, isSelected, onSelect, onViewDocs }) => {
  const {
    candidateId,
    applicationId,
    firstName,
    lastName,
    email,
    gender,
    previousRole,
    applicationStatus,
  } = candidates;

  const navigate = useNavigate();
  const { jobId } = useParams();
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  const phoneDisplay = getPhone(candidates);

  const goToDashboard = () => {
    navigate(`/candDashboard/${candidateId}`, {
      state: { candidateId, applicationId, jobId, fullName },
    });
  };

  const handleViewDocs = () => {
    if (typeof onViewDocs === "function") {
      onViewDocs({ jobId, candidateId, fullName });
    }
  };

  return (
    <tr className="border-t hover:bg-gray-50">
      <td className="p-4">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onSelect({ candidateId, applicationId })}
        />
      </td>
      <TexCell
        text={candidateId}
        className="text-blue-600 cursor-pointer hover:underline"
        onClick={goToDashboard}
      />
      <TexCell
        text={fullName}
        className="text-blue-600 cursor-pointer hover:underline"
        onClick={goToDashboard}
      />
      <TexCell text={email} />
      <TexCell text={gender} />
      <TexCell text={phoneDisplay} />
      <TexCell text={previousRole} />
      <TexCell text={applicationStatus} />
      {/* More Documents */}
      <td className="p-4">
        <button
          onClick={handleViewDocs}
          className="px-3 py-1 text-sm font-medium text-black bg-[#FFCC00] rounded-md shadow hover:opacity-90"
          title="View other documents"
        >
          View
        </button>
      </td>
    </tr>
  );
};

export default CandidatesRow;
